import React, { ReactElement } from 'react';
import { Box } from '@chakra-ui/react';
import { NextPageWithLayout } from '@app/pages/_app';
import { useInitialTokensData } from '@app/screens/liquidity/LiquidityWizard/hooks/useInitialTokensData';
import { LiquidityWizard } from '@app/screens/liquidity/LiquidityWizard';

import Metadata from '@app/components/Metadata';
import AnimatedLayout from '@app/layouts/AnimatedLayout/AnimatedLayout';

const LiquidityWizardPage: NextPageWithLayout = () => {
  const { initialData } = useInitialTokensData();

  return <LiquidityWizard initialData={initialData} />;
};

LiquidityWizardPage.getLayout = function getLayout(page: ReactElement) {
  return (
    <AnimatedLayout>
      <Metadata title={'Liquidity | Kim'} />
      <Box width="100%" mt={4} px={[0, 7]}>
        {page}
      </Box>
    </AnimatedLayout>
  );
};

export default LiquidityWizardPage;
